import { Outlet, useLocation, useParams } from "react-router-dom";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";

const Layout = () => {
    const { lang } = useParams();
    const { pathname } = useLocation();
    const getCurrentPath = () => pathname.replace(`/${lang}`, '').replace(/\/$/, "");

    return (
        <div className="ovf-hidden">
            <Header />
            <Outlet />
            {getCurrentPath() !== '/contact' &&
                <Footer />
            }
        </div>
    );
};

export default Layout;

